<template>
    <div class="carBox" @mouseup="handleMouseUp">
        <el-card ref="left_tree" class="box-card treeBox" style="height: calc(100vh - 152px);width: 300px;overflow-y: auto">
            <el-tree :data="projectDivisionData" node-key="value" :current-node-key="pid" :highlight-current="true" ref="my-tree" @node-click="clickPrjectDivision" :default-expanded-keys="openKeys" :expand-on-click-node="false">
                <span slot-scope="{ node }" class="custom-tree-node treeTitle" :title="node.label.split('###')[1]" v-text="node.label.split('###')[0]"></span>
            </el-tree>
        </el-card>
        <div ref="resizeHandle" class="handle-resize" />
        <div ref="moveDiv" class="handle-resize-h" />
        <div class="newBox" style="width: calc(100% - 290px)">
        <div class="searchBox">

            <div class="searchGroup">
                <label>灌浆类型：</label>
                <el-select v-model="search_Obj.f_grout_type" clearable placeholder="请选择" @keyup.enter.native="doSearch">
                    <el-option v-for="item in enuObj('grout_type')" :key="'grout_type'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </div>
            <div class="searchGroup">
                <label>作业方式：</label>
                <el-select v-model="search_Obj.f_work_type_int" clearable placeholder="请选择" @keyup.enter.native="doSearch">
                    <el-option v-for="item in enuObj('work_type_int')" :key="'work_type_int'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </div>
            <div class="searchGroup">
                <label>孔号：</label>
                <el-input v-model="search_Obj.f_hole_code" clearable @keyup.enter.native="doSearch" style="width: 150px"></el-input>
            </div>
            <div class="searchGroup">
                <label>开始时间：</label>
                <el-date-picker v-model="dateRange" type="daterange" value-format="yyyy-MM-dd" unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions"
                    @change="dateRangeSet"
                    style="width:320px">
                </el-date-picker>
            </div>
            <el-button type="primary" size="medium" icon="el-icon-search" @click.native="doSearch">搜索</el-button>
        </div>
    <el-card ref="right_content" class="box-card">
        <div class="mainBody">
        <div class="btnBox">
            <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
        </div>
            <div class="dataBox">
                                <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                                    <el-table-column prop="unit_code" label="单元编号" sortable="custom"></el-table-column>
                                    <el-table-column prop="hole_code" label="孔号" sortable="custom" width="130"></el-table-column>
                                    <el-table-column prop="hole_order" label="孔序" sortable="custom" width="100"></el-table-column>
                                    <el-table-column prop="segment_no" label="段号" sortable="custom" width="100"></el-table-column>
                                    <el-table-column prop="grout_type" label="灌浆类型" sortable="custom" width="120">
                                        <template slot-scope="scope">
                                            <span>{{ transEnu(scope.row.grout_type, "grout_type") }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="work_type" label="作业方式" sortable="custom" width="120"></el-table-column>
                                    <el-table-column prop="begin_time" label="作业时间" sortable="custom" width="200">
                                        <template slot-scope="scope">
                                            <span>{{ scope.row.begin_time }}</span><br>
                                            <span>{{ scope.row.end_time }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="segment_length" label="段长(m)" sortable="custom" width="100"></el-table-column>
                                    <el-table-column prop="grout_volume" label="注浆量(L)" sortable="custom" width="120"></el-table-column>
                                    <el-table-column prop="ash_volume" label="注灰量(Kg)" sortable="custom" width="120"></el-table-column>
                                    <el-table-column label="操作" width="120" align="center">
                                        <template slot-scope="scope">
                                            <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
            <div class="pageBox">
                                <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50]" :current-page="current" :page-size="pagesize" :total="total" @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
                            </div>
            <AbNormalInfo
                                :id="model_id"
                                title="处理异常作业报告"
                                :isshow="editshow"
                                @on-close="closeEditDialog"
                                @on-save-ok="saveOk">
                            </AbNormalInfo>
        </div>
    </el-card>
</div>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import AbNormalInfo from "./abnormalInfo"
import listutil from "@/libs/listutil"
import { getListData } from '@/api/common'
import { getProjectDivisionTreeData } from '@/api/org'

export default {
    name: 'workreportAbnormal',
    mixins: [listutil],
    components: {AbNormalInfo, Btns, LabBtns},
    data() {
        return {
            m_name: '数据报告',
            menu_id: 5300,
            list_url: "/api/admin/workreport/list",
            search_Obj: {
                f_report_type: 1,
                f_state: 0,
                f_grout_type: '',
                f_work_type: '',
                f_hole_code: '',
            },
            del_Obj:{
                url:'/api/admin/workreport/de1l',
                data:{
                    ids:''
                }
            },
            enu_name: ['grout_type','work_type_int'],
            pid: 0,
            projectDivisionData: [],
            openKeys: [],
            sortData: {
                prop: 'order_index',
                order: 'ascending'
            },
            dateRange: '',
        };
    },
    mounted(){
        this.dragControllerDiv(this.$refs.left_tree.$el, this.$refs.resizeHandle, this.$refs.moveDiv)
    },
    methods: {
        loadOtherData() {
            this.initTree()
        },
        initTree(){
            this.projectDivisionData = []
            getProjectDivisionTreeData(2).then(res=>{
                if(res.code ==1){
                    var treeData = res.data
                    treeData = this.removeEmptyChild(treeData)
                    this.projectDivisionData = treeData
                    this.initOpenKeys()
                }
            })
        },
        initOpenKeys(){//哪些节点要展开
            this.openKeys = this.getAllNodeId(this.openKeys, this.projectDivisionData, 0)
        },
        getAllNodeId (expandedKeys, moduleDataList, level) {
            if(level>1){
                return expandedKeys
            }
            for (let i = 0; i < moduleDataList.length; i++) {
                expandedKeys.push(moduleDataList[i].value)
                if (moduleDataList[i].children) {
                    expandedKeys = this.getAllNodeId(expandedKeys, moduleDataList[i].children, level+1)
                }
            }
            return expandedKeys
        },
        getListData() {
            this.loading = true;
            this.selectData = [];
            getListData(this.list_url, this.search_Obj).then(res => {
                this.loading = false;
                if (res.code === 1) {
                    this.tableData = res.data.resultList;
                    this.total = res.data.totalRecords;
                    this.pid = res.data.pid
                    setTimeout(() => {
                        this.$refs["my-tree"].setCurrentKey(this.pid);
                    }, 1000);
                }
            })
        },
        clickPrjectDivision(data){
            this.search_Obj.pid = data.id
            this.current = 1
            this.getListData()
        },
        dateRangeSet(val){
            if(this.$isNotNull(val)){
                this.search_Obj.f_begin_time_s_date = val[0]
                this.search_Obj.f_begin_time_e_date = val[1]
            }else{
                this.search_Obj.f_begin_time_s_date = ''
                this.search_Obj.f_begin_time_e_date = ''
            }
        },
        deal(index, row){
            this.model_id = row.id
            this.editshow = true
        }
    }
};
</script>